export default "__VITE_ASSET__D3O$Yn5P__"